// A selection is keyed by the row/column ids when the data carries them, so it
// follows its cell through a reorder or a hidden row. The index is the fallback
// for data without ids; it still keeps same-named rows apart.
export const cellKey = (labels: any, rowIdx: number, colIdx: number) =>
  `${labels.rowValue ?? `#${rowIdx}`}|${labels.columnValue ?? `#${colIdx}`}`;

// An empty cell has nothing to open.
export const isCellClickable = (labels: any) => !!labels?.hasData && labels.count !== 0;

// The selected cell's current labels, or null once it's gone or emptied.
export const findSelectedCell = (tableData: any[][], key: string | null) => {
  if (!key) return null;
  for (let r = 0; r < tableData.length; r++) {
    for (let c = 0; c < (tableData[r]?.length ?? 0); c++) {
      const labels = tableData[r][c]?.labels;
      if (labels && cellKey(labels, r, c) === key) {
        return isCellClickable(labels) ? labels : null;
      }
    }
  }
  return null;
};
